<template>
  <Popup title="报警器详细" minHeight="100%" ref="popup">
    <div>
      <van-cell title="客户名称" :value="statusData.companyName" />
      <van-cell title="地址" :value="statusData.address" />
      <van-cell title="电话" :value="statusData.phoneNum" />
      <van-cell title="报警器编号" :value="statusData.eqId" />
      <van-cell title="报警器名称" :value="statusData.eqName" />
      <van-cell title="报警器位置" :value="statusData.eqPosition" />
      <van-cell title="检测气体" :value="statusData.gasTypeName" />
      <van-cell title="当前状态" :value="statusData.eqStatusName" />
      <van-cell title="生产厂家" :value="statusData.eqUnitName" />
      <van-cell title="生产日期" :value="statusData.makeDate" />
    </div>
  </Popup>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'AlarmDetail', // 报警器详细
  setup() {
    const popup = ref(null)
    const statusData = ref({})
    const showPopup = (data) => {
      console.log(data)
      statusData.value = data
      popup.value.showPopup()
    }

    return {
      popup,
      showPopup,
      statusData
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  margin-bottom: 20px;
}
</style>
